var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var propertyMapper = {
    string: 'text',
    integer: 'number',
    float: 'number',
    time: 'timestamp',
    richtext: 'text',
    location: 'coordinates',
    date: 'timestamp',
    text: 'text',
    number: 'number',
    timestamp: 'timestamp',
    coordinates: 'coordinates',
    array: 'array',
    boolean: 'boolean',
    json: 'json',
    image: 'image',
    file: 'file',
    url: 'url',
};
export var getSortedTargetProperties = function (targetProperties, edgeMeta) {
    var propertiesWithParamMapped = [];
    var propertiesWithoutParamMapped = [];
    targetProperties === null || targetProperties === void 0 ? void 0 : targetProperties.forEach(function (property) {
        var _a;
        if ((property === null || property === void 0 ? void 0 : property.dataField) && ((_a = edgeMeta.params) === null || _a === void 0 ? void 0 : _a[property.dataField])) {
            propertiesWithParamMapped.push(property);
        }
        else {
            propertiesWithoutParamMapped.push(property);
        }
    });
    return __spreadArray(__spreadArray([], propertiesWithParamMapped, true), propertiesWithoutParamMapped, true);
};
export var key = function (index, propertyId, sourcePatchId, targetPatchId) {
    return "".concat(index, ":").concat(propertyId.toLowerCase(), ":").concat(sourcePatchId, ":").concat(targetPatchId);
};
export var formatTargetPropertiesForSendDeepLinkedPush = function (formattedTargetProperties, receiverApps) {
    var formattedTargetPropertiesForSendDeepLinkedPush = [];
    formattedTargetProperties === null || formattedTargetProperties === void 0 ? void 0 : formattedTargetProperties.forEach(function (property) {
        var _a, _b;
        if (property === null || property === void 0 ? void 0 : property.dataField.includes('inputPushAppId')) {
            var appId_1 = (_a = property === null || property === void 0 ? void 0 : property.dataField) === null || _a === void 0 ? void 0 : _a.split('_')[1];
            var appName = (_b = receiverApps.find(function (r) { return r.app_id === appId_1; })) === null || _b === void 0 ? void 0 : _b.app_name;
            appName &&
                formattedTargetPropertiesForSendDeepLinkedPush.push(__assign(__assign({}, property), { dataField: "Scope: ".concat(appName) }));
        }
        else {
            formattedTargetPropertiesForSendDeepLinkedPush.push(property);
        }
    });
    return formattedTargetPropertiesForSendDeepLinkedPush;
};
